import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Select as AntSelect } from 'antd';

export const Select = styled(AntSelect)`
  &.ant-select-single .ant-select-selector {
    font-size: 1.25rem;
  }
`;

export const globalSelectStyles = css`
  .custom-questionnaire-select-dropdown {
    background-color: transparent !important;
    box-shadow: none !important;

    .ant-select-item.ant-select-item-option {
      display: flex;
      align-items: center;
      font-size: 1.25rem;
      color: #7b8b84;
      height: 4rem;
      border: 1px solid #0e2a27;
      border-radius: 4rem;
      padding: 0 24px;
      margin-right: 16px;

      @media (max-width: 768px) {
        background-color: #ffffff;
        height: 3rem;
        font-size: 1.125rem;
        padding: 0 16px;
      }

      @media (max-width: 480px) {
        height: 2rem;
        font-size: 1rem;
        padding: 0 12px;
      }

      &:not(:last-child) {
        margin-bottom: 8px;
      }

      &.ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
        background-color: #9db98b;
        border: unset;
        color: #0e2a27;
      }
    }
  }
`;
